import * as iots from 'io-ts';

export const userDefinedSurveyConfigCodec = iots.type({
  primaryColor: iots.string,
  secondaryColor: iots.string,
  primaryButtonText: iots.union([iots.literal('light'), iots.literal('dark')]),
  shouldDisplayPoweredByFront: iots.boolean,
  surveyPrompt: iots.string,
  answerFieldPlaceholderText: iots.string,
  buttonText: iots.string,
  companyLogo: iots.union([
    iots.type({
      url: iots.string,
    }),
    iots.undefined,
  ]),
});

export type SurveyConfig = iots.TypeOf<typeof userDefinedSurveyConfigCodec>;

export const defaultSurveyConfig: SurveyConfig = {
  surveyPrompt: 'Please provide your feedback',
  answerFieldPlaceholderText: 'Tell us more',
  buttonText: 'Submit',
  primaryColor: '#F5F5F5',
  secondaryColor: '#367FEE',
  primaryButtonText: 'light',
  shouldDisplayPoweredByFront: true,
  companyLogo: undefined,
};
